export default () => {
  if ($('.related-items').length) {

    const $component = $('.related-items'),
          $window = $(window),
          elemOffset = $component.offset().top;
    let windowTop = $window.scrollTop();

    $window.on('scroll', () => {
      windowTop = $window.scrollTop();

      if (windowTop > elemOffset - 70) {
        $component.addClass('-fixed-js');
      } else {
        $component.removeClass('-fixed-js');
      }
    });
  }

};